export default __webpack_public_path__ + "static/media/banner.b15f6c6e.png";